var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-window',{ref:"window",staticClass:"fwindow-width-3",attrs:{"title":_vm.$t('notice')}},[_vm._v(" Please, select "),_c('b',[_vm._v("Fantom Opera")]),_vm._v(" network in the Metamask. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }